import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ReactQueryKeys } from 'enums';
import { UserRole } from 'modules/2023-q4/rbac/enums/user-role';

export const useUpdateTeamMemberRole = (): UseMutationResult<
  { approvalRequired?: boolean },
  unknown,
  { memberId: string; role: UserRole.ADMIN | UserRole.READ_ONLY }
> => {
  const queryClient = useQueryClient();
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  const updateTeamMemberRole = async ({
    memberId,
    role,
  }: {
    memberId: string;
    role: UserRole.ADMIN | UserRole.READ_ONLY;
  }) => {
    const { data } = await treasureApi().patch(`/users/${memberId}/role`, {
      role,
    });

    return data;
  };

  return useMutation(updateTeamMemberRole, {
    onSuccess: () => {
      queryClient.refetchQueries(ReactQueryKeys.BusinessMembers);
      queryClient.refetchQueries(ReactQueryKeys.ApprovalPolicy);
    },
  });
};
